var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoovingBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 314.226,
    height: 108.677,
    viewBox: "0 0 314.226 108.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(-32.2 -106.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7628",
    "data-name": 7628,
    transform: "translate(10.946 69.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 11.354,
    height: 11.015,
    rx: 5.507,
    transform: "translate(174.736 68.202)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 10.37,
    height: 10.06,
    rx: 5.03,
    transform: "translate(175.229 68.679)",
    fill: "#dfebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M2317,736.115a.235.235,0,1,1,.235.235A.235.235,0,0,1,2317,736.115Z",
    transform: "translate(-2136.819 -666.431)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M2342.245,742.041a.236.236,0,1,1-.021.179A.236.236,0,0,1,2342.245,742.041Z",
    transform: "translate(-2160.169 -672.024)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M2363.207,760.549a.234.234,0,1,1-.1.147A.235.235,0,0,1,2363.207,760.549Z",
    transform: "translate(-2179.504 -689.241)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M2372.525,788a.235.235,0,1,1-.235.235.235.235,0,0,1,.235-.235Z",
    transform: "translate(-2188.018 -714.694)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M2364.9,818.517a.234.234,0,1,1-.166-.069.234.234,0,0,1,.166.069Z",
    transform: "translate(-2180.799 -742.889)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M2344.972,838.522a.235.235,0,1,1-.167-.069A.235.235,0,0,1,2344.972,838.522Z",
    transform: "translate(-2162.348 -761.413)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M2317,846.755a.234.234,0,1,1,.068.167A.235.235,0,0,1,2317,846.755Z",
    transform: "translate(-2136.819 -768.883)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M2292.064,742.041a.236.236,0,1,0,.021.179A.236.236,0,0,0,2292.064,742.041Z",
    transform: "translate(-2113.32 -672.024)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M2271.067,760.528a.235.235,0,1,0,.071.325A.235.235,0,0,0,2271.067,760.528Z",
    transform: "translate(-2093.949 -689.22)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M2261.776,788a.235.235,0,1,0,.234.235A.236.236,0,0,0,2261.776,788Z",
    transform: "translate(-2085.463 -714.694)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M2269.419,818.512a.235.235,0,1,0,.166-.069A.235.235,0,0,0,2269.419,818.512Z",
    transform: "translate(-2092.695 -742.884)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M2289.378,838.522a.235.235,0,1,0,.167-.069A.235.235,0,0,0,2289.378,838.522Z",
    transform: "translate(-2111.178 -761.413)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M2319.29,788.255a.234.234,0,1,1,.068.167A.235.235,0,0,1,2319.29,788.255Z",
    transform: "translate(-2138.94 -714.712)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 0.064,
    height: 2.938,
    transform: "translate(180.554 70.605)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 1.98,
    height: 0.192,
    transform: "translate(180.492 73.451) rotate(-38.15)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M2002.455,1097.242s1.251-1.458.074-2.385a3.343,3.343,0,0,0-1.554-.477s.99,1.661.67,1.826-.97-1.929-.97-1.929a7.863,7.863,0,0,0-2.577.113s1.667,1.364,1.316,1.445-2.152-1.258-2.152-1.258-1.815.309-1.718,1.416.722,1.45,1,1.42,1.883-.643,1.918-.418-.932.962-1.61,1c0,0,1.28,1.411,2.131,1s.922-1.053,1.453-1.3.983-.241.764.005-1.179.488-1.48,1.023-.576.9.3.766,2.311-.776,2.373-1.513Z",
    transform: "translate(-1839.147 -998.251)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M2007.62,1118.5s4.931-.19,6.019,1.22a3.57,3.57,0,0,0,.982,1.378l.115.314s-.854-.9-1.16-.954C2013.576,1120.46,2014.054,1118.713,2007.62,1118.5Z",
    transform: "translate(-1850.333 -1020.731)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M2098.751,1152.16a3.1,3.1,0,0,1,1.132,2.181l-.192.018a5.008,5.008,0,0,0-.949-2.011C2098.133,1151.782,2098.751,1152.16,2098.751,1152.16Z",
    transform: "translate(-1934.464 -1051.792)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M2131.639,1045.816s-1.989-1.11-1.061-2.625a3.923,3.923,0,0,1,1.538-1.167s-.424,2.254,0,2.307.3-2.546.3-2.546a9.335,9.335,0,0,1,2.917-.928s-1.3,2.2-.875,2.146,1.883-2.281,1.883-2.281,2.146-.4,2.494.875-.213,1.91-.531,1.989-2.361.053-2.308.318,1.432.69,2.2.451c0,0-.849,2.095-1.963,1.989s-1.459-.8-2.146-.849-1.193.132-.849.318,1.512.061,2.068.534,1.008.765-.027.978-2.89.079-3.262-.716Z",
    transform: "translate(-1963.964 -948.66)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M2147.616,1058.69s-5.57,1.8-6.206,3.819a4.227,4.227,0,0,1-.53,1.936v.4a5.8,5.8,0,0,1,.9-1.539S2140.535,1061.554,2147.616,1058.69Z",
    transform: "translate(-1973.732 -965.353)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M2134.365,1133.359a3.674,3.674,0,0,0-.37,2.892l.222-.059a5.935,5.935,0,0,1,.235-2.628C2134.9,1132.683,2134.365,1133.359,2134.365,1133.359Z",
    transform: "translate(-1967.217 -1034.266)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M1984.9,1004.571s2.622-1.468,1.4-3.461a5.208,5.208,0,0,0-2.028-1.538s.559,2.972,0,3.041-.385-3.356-.385-3.356-2.762-1.332-3.848-1.224c0,0,1.713,2.9,1.154,2.832s-2.482-3.007-2.482-3.007-2.832-.525-3.287,1.154.28,2.516.7,2.622,3.108.074,3.041.42-1.888.91-2.9.592c0,0,1.118,2.762,2.59,2.622s1.924-1.048,2.831-1.119,1.573.175,1.119.42-1.993.08-2.727.7-1.328,1.009.035,1.288,3.811.1,4.3-.944Z",
    transform: "translate(-1820.389 -908.951)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M1994.73,1021.51s7.342,2.377,8.181,5.032a5.58,5.58,0,0,0,.7,2.552v.524a7.65,7.65,0,0,0-1.189-2.027S2004.064,1025.285,1994.73,1021.51Z",
    transform: "translate(-1838.397 -930.924)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M2110.344,1119.945a4.842,4.842,0,0,1,.487,3.812l-.292-.074a7.831,7.831,0,0,0-.309-3.465C2109.638,1119.058,2110.344,1119.945,2110.344,1119.945Z",
    transform: "translate(-1945.132 -1021.775)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M2042.205,1172.606a5.136,5.136,0,0,1-5.136-5.136h10.272A5.137,5.137,0,0,1,2042.205,1172.606Z",
    transform: "translate(-1877.604 -1066.083)",
    fill: "#8cb4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M2054.744,1172.566a5.036,5.036,0,0,1-.638.04,5.137,5.137,0,0,1-5.136-5.135h1.276A5.136,5.136,0,0,0,2054.744,1172.566Z",
    transform: "translate(-1888.623 -1066.083)",
    fill: "#99c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M2036.11,1232.474h10.414a.634.634,0,0,0-.633-.634h-9.147A.634.634,0,0,0,2036.11,1232.474Z",
    transform: "translate(-1876.715 -1125.689)",
    fill: "#8cb4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 10.558,
    height: 0.158,
    transform: "translate(169.906 101.544) rotate(180)",
    fill: "#99c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M650.8,1215.06l.765,3.91-1.65.138-1.861-3.806Z",
    transform: "translate(-591.372 -1110.151)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M1366.536,1124.68l.764,3.91-1.65.138-1.861-3.806Z",
    transform: "translate(-1254.147 -1026.46)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 11.646,
    height: 9.603,
    transform: "translate(65.93 135.884) rotate(180)",
    fill: "#c3dafc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 11.646,
    height: 9.603,
    transform: "translate(71.752 135.884) rotate(180)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M615.78,1589.59h1.845l-.162-.519.162-.371H615.78Z",
    transform: "translate(-561.491 -1456.142)",
    fill: "#9dc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M694.38,1532.89h1.846l-.162-.519.162-.371H694.38Z",
    transform: "translate(-634.274 -1403.637)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M671.295,1532H669.45l.162.519-.162.371h1.845Z",
    transform: "translate(-611.189 -1403.637)",
    fill: "#9dc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M828.676,1602.13H826.83l.163.519-.163.372h1.846Z",
    transform: "translate(-756.923 -1468.578)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 3.351,
    height: 1.304,
    transform: "translate(67.638 126.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 11.646,
    height: 9.603,
    transform: "translate(84.647 135.884) rotate(180)",
    fill: "#c3dafc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 11.646,
    height: 9.603,
    transform: "translate(90.47 135.884) rotate(180)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M868.73,1589.59h1.845l-.162-.519.162-.371H868.73Z",
    transform: "translate(-795.722 -1456.142)",
    fill: "#9dc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M947.33,1532.89h1.845l-.162-.519.162-.371H947.33Z",
    transform: "translate(-868.505 -1403.637)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M924.235,1532H922.39l.162.519-.162.371h1.845Z",
    transform: "translate(-845.411 -1403.637)",
    fill: "#9dc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M1081.616,1602.13h-1.846l.163.519-.163.372h1.846Z",
    transform: "translate(-991.145 -1468.578)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 3.351,
    height: 1.304,
    transform: "translate(86.356 126.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 11.646,
    height: 9.603,
    transform: "translate(75.918 126.392) rotate(180)",
    fill: "#c3dafc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 11.646,
    height: 9.603,
    transform: "translate(81.742 126.392) rotate(180)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M750.78,1461.321h1.846l-.163-.52.163-.371H750.78Z",
    transform: "translate(-686.5 -1337.364)",
    fill: "#9dc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M829.38,1404.621h1.846l-.163-.52.163-.371H829.38Z",
    transform: "translate(-759.284 -1284.86)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M806.285,1403.73H804.44l.162.52-.162.371h1.846Z",
    transform: "translate(-736.19 -1284.86)",
    fill: "#9dc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M963.675,1473.86H961.83l.162.52-.162.371h1.845Z",
    transform: "translate(-881.932 -1349.8)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 3.351,
    height: 1.304,
    transform: "translate(77.629 117.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M653.279,680.028c-.157.481-2.091,1.121-4.99,1.817-.511.123-1.051.246-1.617.37-9.884,2.189-37.216,5.779-38.941,5.637-2.382-.2-9.411-21.674-9.411-21.674s13.649-1.706,24.494-2.993c3.711-.44,16.622-1.934,19.018-2.194C645.544,660.59,653.53,679.249,653.279,680.028Z",
    transform: "translate(-545.323 -597.077)",
    fill: "#b0d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M1193.962,675.745s-5.833-14.606-6.273-15.836a1.047,1.047,0,0,0-1.059-.715c.73-.148,1.267-.21,1.267-.21a3.4,3.4,0,0,1,3.457,1.928c1.339,2.857,3.977,8.34,6.478,13.709C1197.736,674.626,1193.962,675.745,1193.962,675.745Z",
    transform: "translate(-1090.097 -595.206)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M1405.839,830.586c-.26,3.848-4.376,6.734-8.866,7.219l-8.894.962-1.679-21.9s8.21-3.514,10.59-1.463c2.084,1.8,8.006,9.16,8.781,13.814A5.883,5.883,0,0,1,1405.839,830.586Z",
    transform: "translate(-1275.084 -739.472)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M1483.512,1028.65c-.26,3.848-4.376,6.734-8.866,7.22l-4.366.473C1473,1034.291,1475.053,1028.653,1483.512,1028.65Z",
    transform: "translate(-1352.757 -937.536)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M1310.25,826.693s11.412-6.695,14.067-3.419c1.41,1.74,5.54,8.842,6.294,13.5.732,4.525-3.42,8-8.025,8.5l-8.179.888Z",
    transform: "translate(-1204.569 -746.522)",
    fill: "#aac8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M898.669,881.141q-.183.171-.377.338a19.291,19.291,0,0,1-6.281,3.452,27.736,27.736,0,0,1-6.258,1.354l-3.889.423-.053.006-18.408,2-10.552,1.148-.156.017h0l-.56-1.755-5.306-17.734S892.962,864.4,896.94,866c1.85.744,3.256,4.5,4.269,8.7C901.751,876.942,900.74,879.206,898.669,881.141Z",
    transform: "translate(-775.443 -786.671)",
    fill: "#9fc3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M965.044,1074q-.183.171-.377.338a19.3,19.3,0,0,1-6.281,3.452,27.753,27.753,0,0,1-6.258,1.354l-3.889.423-.053.006-18.408,2-10.552,1.148-.158.013-.56-1.755a135.764,135.764,0,0,1,24.506-4.953C951.941,1075.147,959.406,1074.326,965.044,1074Z",
    transform: "translate(-841.818 -979.53)",
    fill: "#8bb3ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M815.194,895.485c-.323,3.743-4.029,6.494-8.085,6.935l-8.179.888-1.75-22.091s7.543-3.246,9.75-1.177c1.934,1.812,7.45,9.22,8.2,13.877A6.316,6.316,0,0,1,815.194,895.485Z",
    transform: "translate(-729.467 -799.284)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M857.54,1097.39c-.323,3.743-4.029,6.494-8.085,6.934l-6.545.711C845.775,1102.873,849.355,1097.372,857.54,1097.39Z",
    transform: "translate(-771.813 -1001.189)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M549.051,753.681a6.7,6.7,0,0,1-1.9,3.881h0a9.1,9.1,0,0,1-2.172,1.646,10.669,10.669,0,0,1-3.3,1.16l-.182.03-.148.021c-.081.013-.162.023-.243.033l-.13.015-8.179.888h0l-.471.056c-.841.1-1.72.2-2.535.3l-.4.047-.148.016c-.806.093-1.518.172-2.028.222a15.345,15.345,0,0,1-2.037.082,10.038,10.038,0,0,1-2.316-.323q-.191-.051-.377-.112c-.127-.041-.252-.084-.37-.131a7.163,7.163,0,0,1-.945-.437,7.419,7.419,0,0,1-2.1-1.746,10.2,10.2,0,0,1-1.184-1.776,16.435,16.435,0,0,1-1.162-2.843c-.008-.027-.017-.055-.026-.083q-.229-.74-.428-1.567-.091-.377-.175-.77-.3-1.39-.523-3.005c-.013-.093-.026-.188-.039-.283l-.008-.063q-.171-1.285-.3-2.715-.056-.627-.105-1.282c-.015-.2-.028-.4-.042-.6q-.1-1.526-.165-3.2-.029-.753-.05-1.538-.087-3.235-.052-7.02c.024-2.868.191-4.889.7-5.4a7.961,7.961,0,0,1,3.6-1.444h0c.73-.148,1.266-.209,1.266-.209l.08-.008.056,0c.045,0,.091-.006.135-.007h.2a1.01,1.01,0,0,1,.134.006l.092.008h.008a.2.2,0,0,1,.066.007c.043,0,.084.01.126.016l.085.015.059.011a3.445,3.445,0,0,1,.682.212,3.386,3.386,0,0,1,1.732,1.676c1.255,2.68,3.489,7.465,5.816,12.47l.035.074.4.865c.013.029.027.058.041.087l.021.044.3-.155.01-.006c.4-.211.864-.444,1.36-.684h0q.385-.188.8-.38c.777-.36,1.619-.724,2.477-1.052.38-.148.765-.285,1.148-.412.491-.165.981-.312,1.461-.434l.041-.011.169-.041c.339-.081.671-.148.995-.2h0c1.653-.27,3.063-.127,3.8.784a18.183,18.183,0,0,1,1.092,1.579,51.635,51.635,0,0,1,3.062,5.664,26.231,26.231,0,0,1,2.146,6.3A6.326,6.326,0,0,1,549.051,753.681Z",
    transform: "translate(-467.988 -656.819)",
    fill: "#77a4e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M580.4,742.3s-5.833-14.6-6.273-15.839a1.048,1.048,0,0,0-1.059-.716c.73-.148,1.267-.209,1.267-.209a3.4,3.4,0,0,1,3.456,1.928c1.339,2.858,3.805,8.127,6.306,13.5C584,740.966,580.4,742.3,580.4,742.3Z",
    transform: "translate(-521.941 -656.831)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M1445.393,1127.71c-.045-.026-1.451.334-1.844.343-.343.008-1.636-.283-1.782-.6a16.973,16.973,0,0,0,1.735-.289,2.057,2.057,0,0,1,1.045-.37,3.387,3.387,0,0,0,.651,0Z",
    transform: "translate(-1326.354 -1028.411)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M500.45,874.884s1.359,2.22,3.593,1.714a6.456,6.456,0,0,0,.749-1.837c.016-.1.032-.2.047-.288.148-.909.258-1.416.258-1.416h0c-.09-.055-3.024-1.813-3.038-1.706A5.621,5.621,0,0,1,500.45,874.884Z",
    transform: "translate(-454.695 -791.873)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M525.186,879.775a4.95,4.95,0,0,0,2.558,2.487c.148-.909.257-1.416.257-1.416h0A20.467,20.467,0,0,0,525.186,879.775Z",
    transform: "translate(-477.6 -799.66)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M522.243,818.407s-3.644.3-3.792-1.978-.718-3.764,1.6-4.049,2.83.554,3.064,1.3S523.188,818.272,522.243,818.407Z",
    transform: "translate(-471.206 -737.218)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M497.19,795.841c-.053.024-.845.142-1.85-2.932a2.516,2.516,0,0,1,.491-2.253c.655-.778,2.617-1.17,4.207-1.229s1.829.867,2.061,1.8a4.779,4.779,0,0,0,1.232,1.9c-1.445.542-2.89-.766-3.472-.675s-.912.938-1,1.212-.184.5-.846.141-.466.943-.39,1.2C497.631,795,497.631,795.645,497.19,795.841Z",
    transform: "translate(-449.882 -716.012)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M472.617,1597.535H466.9a.507.507,0,0,1-.121-.035c-.382-.191-.262-1.652-.216-2.1.008-.083.015-.132.015-.132s2.008-1.607,2.285-.377c.009.039.018.074.03.113h0c.349,1.151,1.907,1.674,2.807,1.82A.989.989,0,0,1,472.617,1597.535Z",
    transform: "translate(-423.27 -1461.443)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M289.68,1569.833h-2.155c-.452,0-.954-.452-1.08-1.28s-1.055-1.28-1.258-1.958.828-1.632.828-1.632l.172-.222.179-.231,1.707.4s.042.406.068.924a11.716,11.716,0,0,1,.007,1.184c-.05.9.253,1.878,1.056,2.054S289.68,1569.833,289.68,1569.833Z",
    transform: "translate(-255.337 -1433.742)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M426.716,1184.753s-.3,3.807-.666,8.381c-.487,6.216-1.073,13.849-1.131,15.3-.1,2.511-.5,6.528-.5,6.528a3.158,3.158,0,0,1-2.862.552,65.6,65.6,0,0,1-2.187-11.8c-.007-.1-.016-.2-.023-.3-.452-6.177-1.154-19.182-1.154-19.182Z",
    transform: "translate(-378.522 -1081.603)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M425.2,1185.505s.6,1.37-.5,5.825c-.806,3.269-5.309,12.378-5.309,12.378-.007-.1-.016-.2-.023-.3-.452-6.177-1.154-19.182-1.154-19.182Z",
    transform: "translate(-378.55 -1081.603)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M313.086,1165.637s-5.755,14.489-9.371,20.967-4.745,8.288-4.745,8.288-2.072-.829-2.26-1.393c0,0,1.382-12.506,3.8-15.554,1.368-1.723,2.976-6.892,3.051-8.7s.489-5.386.489-5.386Z",
    transform: "translate(-266.032 -1062.74)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M415.13,928.465c-.776-.222-8.693-3.322-8.538-3.774a73.322,73.322,0,0,0,1.753-7.4c.124-.6.263-1.184.415-1.759a27.339,27.339,0,0,1,1.433-4.134,8.413,8.413,0,0,1,4.018-4.366c.173-.066.537.483,1.248,1.11a3.072,3.072,0,0,0,2.1.615l.611,1.08a8.806,8.806,0,0,1,.971,3.324S415.2,928.485,415.13,928.465Z",
    transform: "translate(-367.781 -824.913)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M409.333,986.735l-2.368-.255-5.865,7.114a3.162,3.162,0,0,1-3.482.974h0L396,999.6l9.951,3.212Z",
    transform: "translate(-357.974 -898.486)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M505.527,909.826c-.343-.652-1.527-2.525-1.527-2.525s.148-.079.2-.1.215-.089.215-.089a12.581,12.581,0,0,1,1.869,2.59c.467.84,1.588,3.383,1.588,3.383l-.9-.1S505.933,910.593,505.527,909.826Z",
    transform: "translate(-457.982 -824.99)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M560.059,1188.81a2.585,2.585,0,0,0,.941.3,4.27,4.27,0,0,1,1.119.148c.521.107.542.286.155.37s-.825-.079-.628.13,2.056.388,2.034.625a3.329,3.329,0,0,1-2.333.707,11.236,11.236,0,0,1-2.066-1.48Z",
    transform: "translate(-509.171 -1085.844)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M461.337,951.377c.536-.417.386-.754.386-.754s-3.665-5.97-3.922-6.53.29-7.77.29-7.77.334-2.876-1.071-3.729c-1.221-.74-1.624-1.349-2.5-.807a5.349,5.349,0,0,0-1.726,4.263c.494,2.715,1.131,7.861,1.628,8.9,1.11,2.322,6.026,6.821,6.026,6.821a2.149,2.149,0,0,0,.891-.4Z",
    transform: "translate(-410.533 -847.649)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M1651.182,877.54s-2.014,1.645-3.958.434a6.474,6.474,0,0,1-.1-1.981c.018-.1.035-.2.05-.287.159-.908.222-1.422.222-1.422h0c.1-.022,3.453-.716,3.431-.61A5.622,5.622,0,0,0,1651.182,877.54Z",
    transform: "translate(-1516.471 -794.018)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M1651.6,880.295a4.949,4.949,0,0,1-3.235,1.507c.159-.908.222-1.422.222-1.422h0A20.876,20.876,0,0,1,1651.6,880.295Z",
    transform: "translate(-1517.668 -800.113)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M1638.961,810.057s3.343,1.48,4.232-.619,1.918-3.314-.179-4.35-2.854-.41-3.32.218S1638.114,809.619,1638.961,810.057Z",
    transform: "translate(-1508.669 -730.007)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M1635.5,788.5c.042.039.752.411,2.709-2.161a2.514,2.514,0,0,0,.279-2.289c-.362-.949-2.086-1.967-3.568-2.546s-2.013.215-2.537,1.017a4.779,4.779,0,0,1-1.789,1.386c1.184.989,2.981.229,3.5.507s.553,1.184.542,1.473.009.531.751.412.13,1.044-.026,1.258C1635.356,787.558,1635.145,788.17,1635.5,788.5Z",
    transform: "translate(-1501.204 -708.495)",
    fill: "#a9453d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M1765.163,1566.543h2.156c.451,0,.953-.453,1.079-1.281s1.055-1.28,1.258-1.958-.829-1.632-.829-1.632l-.172-.222-.179-.23-1.707.4s-.042.407-.068.925c-.019.37-.028.807-.008,1.184.05.9-.253,1.877-1.056,2.053S1765.163,1566.543,1765.163,1566.543Z",
    transform: "translate(-1625.757 -1430.695)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M1563.31,1594.24h5.713a.531.531,0,0,0,.121-.036c.381-.191.262-1.651.216-2.1-.009-.083-.016-.132-.016-.132s-2.008-1.607-2.285-.376c-.008.038-.019.074-.03.113h0c-.348,1.151-1.907,1.674-2.808,1.82A.98.98,0,0,0,1563.31,1594.24Z",
    transform: "translate(-1438.903 -1458.391)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M1578.87,1181.4s.305,3.806.666,8.381c.488,6.216,1.073,13.849,1.131,15.294.1,2.511.5,6.528.5,6.528a3.156,3.156,0,0,0,2.862.552,65.559,65.559,0,0,0,2.186-11.8c.008-.1.016-.2.023-.3.452-6.176,1.154-19.182,1.154-19.182Z",
    transform: "translate(-1453.311 -1078.491)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M1594.057,1181.154a23.7,23.7,0,0,0,.9,6.831c.806,3.269,5.308,12.377,5.308,12.377q.012-.148.023-.3c.452-6.176,1.155-19.182,1.155-19.182Z",
    transform: "translate(-1467.362 -1078.501)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M1594.23,1162.337s5.755,14.489,9.37,20.967,4.745,8.288,4.745,8.288,2.072-.829,2.26-1.394c0,0-1.382-12.506-3.8-15.553-1.369-1.723-2.976-6.892-3.051-8.7s-.49-5.385-.49-5.385Z",
    transform: "translate(-1467.535 -1059.684)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M1590.284,931.177c.805.049,9.3-.272,9.3-.747a73.144,73.144,0,0,1,.783-7.567q.119-.907.187-1.8a27.331,27.331,0,0,0,.009-4.376,8.417,8.417,0,0,0-2.355-5.447c-.142-.119-.666.279-1.544.636a3.073,3.073,0,0,1-2.183-.111l-.932.821a8.809,8.809,0,0,0-2.012,2.818S1590.213,931.172,1590.284,931.177Z",
    transform: "translate(-1463.878 -828.797)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M1580.973,967.77l2.321.54,3.194,8.653a3.163,3.163,0,0,0,2.967,2.067h0l-.281,4.269-10.3.768Z",
    transform: "translate(-1453.311 -881.161)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M1483.411,979.914c-.166-.659.16-.832.16-.832s6.567-2.442,7.112-2.726,4.561-6.3,4.561-6.3,1.51-2.47,3.142-2.276a2.957,2.957,0,0,1,2.49,2.092,2.992,2.992,0,0,1-.827,3.267c-2.062,1.835-6.2,5.461-7.234,5.976-2.3,1.146-8.95,1.657-8.95,1.657A2.138,2.138,0,0,1,1483.411,979.914Z",
    transform: "translate(-1364.873 -881.163)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M1629.619,913.692c.54-.5,2.273-1.881,2.273-1.881s-.135-.148-.186-.195c-.032-.031-.141-.122-.141-.122a12.548,12.548,0,0,0-2.617,1.829c-.719.639-2.648,2.664-2.648,2.664l.914.212S1628.983,914.283,1629.619,913.692Z",
    transform: "translate(-1497.231 -829.048)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M1180.027,1264.175v.684c0,.239-.074.434-.173.434H1154.9c-.095,0-.172-.2-.172-.434v-.684c0-.239.074-.435.172-.435h24.952C1179.949,1263.74,1180.027,1263.936,1180.027,1264.175Z",
    transform: "translate(-1060.558 -1155.229)",
    fill: "#9abfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M1244.736,1264.175v.684c0,.239-.074.434-.158.434h-19.809c-.087,0-.158-.2-.158-.434v-.684c0-.239.074-.435.158-.435h19.809C1244.665,1263.74,1244.736,1263.936,1244.736,1264.175Z",
    transform: "translate(-1125.266 -1155.229)",
    fill: "#bad4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 17.715,
    height: 25.82,
    transform: "translate(95.439 110.065)",
    fill: "#c8dbf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 17.715,
    height: 25.82,
    transform: "translate(100.403 110.065)",
    fill: "#dfebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M1267.611,1318.255H1251.8V1294.59h15.811Zm-15.64-.171h15.466v-23.324h-15.466Z",
    transform: "translate(-1150.444 -1183.796)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 15.64,
    height: 0.171,
    transform: "translate(101.44 118.622)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 15.64,
    height: 0.171,
    transform: "translate(101.44 126.604)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M1340.768,1308.812h-2.9a.257.257,0,0,1-.256-.256h0a.256.256,0,0,1,.256-.256h2.9a.257.257,0,0,1,.256.256h0A.257.257,0,0,1,1340.768,1308.812Z",
    transform: "translate(-1229.905 -1196.492)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M1340.768,1414.282h-2.9a.257.257,0,0,1-.256-.256h0a.256.256,0,0,1,.256-.256h2.9a.257.257,0,0,1,.256.256h0A.257.257,0,0,1,1340.768,1414.282Z",
    transform: "translate(-1229.905 -1294.157)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M1340.768,1524.222h-2.9a.257.257,0,0,1-.256-.256h0a.257.257,0,0,1,.256-.256h2.9a.257.257,0,0,1,.256.256h0A.257.257,0,0,1,1340.768,1524.222Z",
    transform: "translate(-1229.905 -1395.961)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 22.329,
    height: 18.411,
    transform: "translate(171.213 135.885) rotate(180)",
    fill: "#c3dafc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 22.329,
    height: 18.411,
    transform: "translate(182.377 135.885) rotate(180)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M1894.25,1549.187h3.538l-.312-1,.312-.711h-3.538Z",
    transform: "translate(-1745.353 -1417.972)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M2044.939,1440.477h3.539l-.312-1,.313-.711h-3.539Z",
    transform: "translate(-1884.891 -1317.306)",
    fill: "#618dc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M2000.668,1438.77h-3.538l.312,1-.312.711h3.538Z",
    transform: "translate(-1840.62 -1317.306)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M2302.408,1573.22h-3.538l.312,1-.312.712h3.538Z",
    transform: "translate(-2120.031 -1441.807)",
    fill: "#618dc1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 6.425,
    height: 2.5,
    transform: "translate(174.489 118.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 12.938,
    height: 10.669,
    transform: "translate(161.006 106.794)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 12.938,
    height: 10.669,
    transform: "translate(154.537 106.794)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M2206.97,1335.769h-2.051l.181-.577-.181-.412h2.051Z",
    transform: "translate(-2033.033 -1221.012)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M2119.65,1272.779H2117.6l.181-.577-.181-.412h2.051Z",
    transform: "translate(-1952.175 -1162.683)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M2145.31,1271.79h2.05l-.18.577.18.412h-2.05Z",
    transform: "translate(-1977.834 -1162.683)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M1970.47,1349.69h2.05l-.181.577.181.412h-2.05Z",
    transform: "translate(-1815.932 -1234.819)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 15.419,
    height: 12.713,
    transform: "translate(172.496 123.17)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 15.419,
    height: 12.713,
    transform: "translate(164.786 123.17)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M2390.813,1575.319h-2.443l.215-.687-.215-.491h2.443Z",
    transform: "translate(-2202.907 -1442.659)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M2286.752,1500.259h-2.443l.215-.688-.215-.491h2.443Z",
    transform: "translate(-2106.548 -1373.154)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M2317.32,1499.08h2.443l-.215.687.215.492h-2.443Z",
    transform: "translate(-2137.116 -1373.154)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M2108.96,1591.92h2.444l-.215.688.215.491h-2.444Z",
    transform: "translate(-1944.174 -1459.123)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 12.891,
    height: 10.629,
    transform: "translate(222.784 96.735) rotate(180)",
    fill: "#d8702a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 12.891,
    height: 10.629,
    transform: "translate(229.229 96.735) rotate(180)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M2718.61,1055.856h2.043l-.18-.575.18-.411h-2.043Z",
    transform: "translate(-2508.71 -961.815)",
    fill: "#c15e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M2805.61,993.1h2.042l-.18-.575.18-.411h-2.042Z",
    transform: "translate(-2589.272 -903.7)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M2780.052,992.11h-2.042l.18.575-.18.411h2.042Z",
    transform: "translate(-2563.714 -903.7)",
    fill: "#c15e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M2954.252,1069.73h-2.042l.18.575-.18.411h2.042Z",
    transform: "translate(-2725.023 -975.576)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 3.71,
    height: 1.443,
    transform: "translate(224.675 86.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M2887.564,1091.5c.313-.2,1.022-.65,1.054-.543a.468.468,0,0,1-.107.335,3.025,3.025,0,0,1,1.85.006.754.754,0,0,1,.481.344.332.332,0,0,1-.135.513c-.524.3-.37.114-1.1.55a2.1,2.1,0,0,1-2.113.175l-.694-.144-.042-1.152S2887.157,1091.552,2887.564,1091.5Z",
    transform: "translate(-2664.417 -995.217)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M2653.46,890.476s1.979,1.618,3.892.428a6.367,6.367,0,0,0,.1-1.948c-.018-.1-.034-.192-.05-.283-.156-.893-.222-1.4-.222-1.4h0c-.1-.022-3.4-.7-3.374-.6A5.5,5.5,0,0,1,2653.46,890.476Z",
    transform: "translate(-2448.381 -806.056)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M2663.716,893.178a4.86,4.86,0,0,0,3.182,1.48c-.156-.892-.222-1.4-.222-1.4h0A20.221,20.221,0,0,0,2663.716,893.178Z",
    transform: "translate(-2457.875 -812.044)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M2647.155,824.082s-3.289,1.454-4.162-.608-1.887-3.263.176-4.278,2.807-.4,3.266.215S2647.988,823.653,2647.155,824.082Z",
    transform: "translate(-2437.73 -743.08)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M2620.3,802.932c-.042.039-.74.406-2.664-2.125a2.475,2.475,0,0,1-.274-2.252c.355-.934,2.051-1.934,3.508-2.5a2.946,2.946,0,0,1,1.835-.085,1.141,1.141,0,0,1,.8,1.416,1.88,1.88,0,0,1-1.825,1.532c-.579-.018-.542,1.166-.532,1.448s-.009.522-.74.405c-.625-.1-.272.725-.062,1.1a1.1,1.1,0,0,1,.148.6A.678.678,0,0,1,2620.3,802.932Z",
    transform: "translate(-2414.809 -721.971)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M2535.412,1568.172h-2.12c-.444,0-.938-.444-1.061-1.258s-1.036-1.258-1.235-1.924.814-1.606.814-1.606l.169-.218.176-.227,1.678.395s.041.4.067.909a11.6,11.6,0,0,1,.007,1.166c-.049.888.249,1.85,1.036,2.019S2535.412,1568.172,2535.412,1568.172Z",
    transform: "translate(-2334.955 -1432.288)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M2715.27,1595.365h-5.618a.549.549,0,0,1-.12-.034c-.375-.188-.257-1.628-.212-2.068.009-.082.015-.131.015-.131s1.976-1.58,2.247-.37c.009.038.018.075.029.111h0c.344,1.132,1.877,1.646,2.761,1.79A.966.966,0,0,1,2715.27,1595.365Z",
    transform: "translate(-2500.057 -1459.481)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M2670.257,1189.274s-.3,3.743-.653,8.243c-.479,6.112-1.055,13.621-1.11,15.043-.1,2.47-.495,6.421-.495,6.421a3.1,3.1,0,0,1-2.812.542,64.565,64.565,0,0,1-2.15-11.607l-.022-.3c-.444-6.075-1.136-18.87-1.136-18.87Z",
    transform: "translate(-2456.178 -1085.788)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M2669.066,1189.024a23.3,23.3,0,0,1-.888,6.718c-.792,3.215-5.221,12.174-5.221,12.174l-.022-.3c-.444-6.075-1.136-18.87-1.136-18.87Z",
    transform: "translate(-2456.104 -1085.788)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M2558.484,1170.551s-5.661,14.248-9.217,20.622-4.667,8.149-4.667,8.149-2.038-.814-2.22-1.37c0,0,1.36-12.3,3.741-15.3,1.346-1.694,2.926-6.779,3-8.556s.481-5.3.481-5.3Z",
    transform: "translate(-2345.521 -1067.314)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M2636.249,943.23c-.792.048-9.148-.268-9.15-.735a71.855,71.855,0,0,0-.771-7.441q-.117-.892-.184-1.769a26.91,26.91,0,0,1-.009-4.3,8.277,8.277,0,0,1,2.317-5.357c.139-.117.655.274,1.519.625a3.019,3.019,0,0,0,2.146-.109l.917.807a8.63,8.63,0,0,1,1.979,2.772S2636.32,943.225,2636.249,943.23Z",
    transform: "translate(-2423.003 -840.263)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M2642.771,979.22l-2.282.531-3.141,8.51a3.108,3.108,0,0,1-2.917,2.033h0l.275,4.2,10.134.76Z",
    transform: "translate(-2430.759 -891.764)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M2664.334,984.064c.074-.666-.268-.79-.268-.79s-6.728-1.49-7.3-1.693-5.3-5.517-5.3-5.517-1.8-2.2-3.369-1.792a2.908,2.908,0,0,0-2.142,2.375,2.943,2.943,0,0,0,1.248,3.071c2.258,1.507,6.778,4.481,7.856,4.843,2.4.805,8.942.4,8.942.4A2.1,2.1,0,0,0,2664.334,984.064Z",
    transform: "translate(-2441.378 -887.136)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M2656.365,926.035c-.531-.494-2.236-1.85-2.236-1.85l.322-.312a12.319,12.319,0,0,1,2.574,1.8c.706.629,2.664,2.6,2.664,2.6l-.962.222S2656.99,926.62,2656.365,926.035Z",
    transform: "translate(-2449.001 -840.512)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M954.063,291.14v9.073a3.831,3.831,0,0,1-.2,1.676h-.03c-.1,0-.181-.633-.2-1.471v-9.27C953.772,291.144,953.918,291.141,954.063,291.14Z",
    transform: "translate(-874.339 -254.602)",
    fill: "#9fc1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M863.486,395.91a7.658,7.658,0,0,0-7.436,7.863h14.874A7.664,7.664,0,0,0,863.486,395.91Z",
    transform: "translate(-783.98 -351.619)",
    fill: "#ff9843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M895.738,396.274a3.063,3.063,0,0,0-.653-.074c-2.676,0-4.845,3.509-4.845,7.838h1.306C891.546,400.07,893.371,396.79,895.738,396.274Z",
    transform: "translate(-815.64 -351.887)",
    fill: "#ffc48a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M841.806,1197.56l.765,3.91-1.65.138-1.862-3.806Z",
    transform: "translate(-768.248 -1093.946)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 214.195,
    height: 0.525,
    rx: 0.262,
    transform: "translate(21.253 135.884)",
    fill: "#2e3552"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(238.985 113.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(61.444 35.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(0 37.197)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 41.768,
    height: 17.863,
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(31.759 47.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M666.231,364.9h-4.019c-1.287,0-2.312,3.415-2.312,7.592,0,4.2,1.024,7.592,2.312,7.592h4.019c1.287,0,2.312-3.415,2.312-7.592S667.518,364.9,666.231,364.9Z",
    transform: "translate(-659.9 -364.9)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(4.807 2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M681.4,379.943c0,3.073-.709,5.543-1.6,5.543s-1.6-2.5-1.6-5.543.709-5.543,1.6-5.543S681.4,376.9,681.4,379.943Z",
    transform: "translate(-678.2 -374.4)",
    fill: "#feeccb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(20.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M634.461,196.665,615.6,182.9v55.008h14.422V232.5a2.984,2.984,0,0,1,3.494-2.942h.053a3.579,3.579,0,0,1,2.968,3.52v4.834h2.154V214.738a4.31,4.31,0,0,0-.052-.578L636.2,199.476A4.452,4.452,0,0,0,634.461,196.665Z",
    transform: "translate(-615.6 -182.9)",
    fill: "#68e52f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(42.687 25.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(0.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M704.481,285.378h-.394a1.289,1.289,0,0,1-1.287-1.287v-3.7a1.289,1.289,0,0,1,1.287-1.287h.394a1.289,1.289,0,0,1,1.287,1.287v3.7A1.273,1.273,0,0,1,704.481,285.378Z",
    transform: "translate(-702.8 -279.1)",
    fill: "#5f45aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M703.181,285.378h-.394a1.289,1.289,0,0,1-1.287-1.287v-3.7a1.289,1.289,0,0,1,1.287-1.287h.394a1.289,1.289,0,0,1,1.287,1.287v3.7A1.273,1.273,0,0,1,703.181,285.378Z",
    transform: "translate(-701.5 -279.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(34.649 13.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M671.058,236.3l-.158,14.212a.515.515,0,0,0,.447.525l6.042,1a.521.521,0,0,0,.6-.6l-2.128-12.9a.511.511,0,0,0-.237-.368l-3.756-2.338A.556.556,0,0,0,671.058,236.3Z",
    transform: "translate(-670.9 -235.76)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(35.28 31.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M675.323,302.051l-1.6-.21a.481.481,0,0,1-.42-.473V301l2.338.289v.473A.282.282,0,0,1,675.323,302.051Z",
    transform: "translate(-673.3 -301)",
    fill: "#e3e6f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(34.071 11.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M676.5,267.477l-.341-.026c.184-4.571-1.97-5.123-1.97-5.149l-5.49-.736V227.6h.341v33.73l5.228.683C674.348,262.013,676.686,262.617,676.5,267.477Z",
    transform: "translate(-668.7 -227.6)",
    fill: "#14345a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(9.457 76.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M351.319,341H344.83c-2.075,0-3.73,5.517-3.73,12.32s1.681,12.32,3.73,12.32h6.488c2.075,0,3.73-5.517,3.73-12.32C355.075,346.517,353.394,341,351.319,341Z",
    transform: "translate(-341.1 -341)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(8.826 4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M377.9,367.9c0,4.545-.709,8.2-1.6,8.2s-1.6-3.678-1.6-8.2c0-4.545.709-8.2,1.6-8.2S377.9,363.378,377.9,367.9Z",
    transform: "translate(-374.7 -359.7)",
    fill: "#feeccb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(50.989 76.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M509.419,341H502.93c-2.075,0-3.73,5.517-3.73,12.32s1.681,12.32,3.73,12.32h6.488c2.075,0,3.73-5.517,3.73-12.32S511.468,341,509.419,341Z",
    transform: "translate(-499.2 -341)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(8.8 4.912)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 1.602,
    cy: 8.196,
    rx: 1.602,
    ry: 8.196,
    fill: "#feeccb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(19.597 76.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M389.919,341H383.43c-2.075,0-3.73,5.517-3.73,12.32s1.681,12.32,3.73,12.32h6.488c2.075,0,3.73-5.517,3.73-12.32C393.675,346.517,391.994,341,389.919,341Z",
    transform: "translate(-379.7 -341)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(8.826 4.912)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 1.602,
    cy: 8.196,
    rx: 1.602,
    ry: 8.196,
    fill: "#feeccb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(61.601 76.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M549.819,341H543.33c-2.075,0-3.73,5.517-3.73,12.32s1.681,12.32,3.73,12.32h6.489c2.075,0,3.73-5.517,3.73-12.32S551.894,341,549.819,341Z",
    transform: "translate(-539.6 -341)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(9.299 4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M578.2,367.9c0,4.545-.709,8.2-1.6,8.2s-1.6-3.678-1.6-8.2c0-4.545.709-8.2,1.6-8.2S578.2,363.378,578.2,367.9Z",
    transform: "translate(-575 -359.7)",
    fill: "#feeccb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(2.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(79.438 35.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M629.155,192.777,615.6,182.9v55.008h13.555Z",
    transform: "translate(-615.6 -182.9)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M313.2,85.015v75.247h56.715V70.1Z",
    transform: "translate(-313.2 -70.1)",
    fill: "#68e52f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(1.839 3.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M373,82.2,320.2,96.112v73.15H373Z",
    transform: "translate(-320.2 -82.2)",
    fill: "#14345a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(56.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M529.1,70.1v90.162h7.854V148.621a4.048,4.048,0,0,1,4.65-4.17l2.259.42a4.725,4.725,0,0,1,3.756,4.729v10.634h17.049V97.608Z",
    transform: "translate(-529.1 -70.1)",
    fill: "#68e52f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(56.715 11.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M564.642,136.166,529.1,114.1v24.352l35.542,13.029Z",
    transform: "translate(-529.1 -114.1)",
    fill: "#332a88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(58.548 5.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 0.604,
    height: 40.139,
    transform: "matrix(0.553, -0.833, 0.833, 0.553, 0, 0.503)",
    fill: "#14345a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(59.267 67.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 0.604,
    height: 33.441,
    transform: "translate(0 0.598) rotate(-81.842)",
    fill: "#14345a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(57.398 41.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 0.604,
    height: 36.934,
    transform: "translate(0 0.572) rotate(-71.331)",
    fill: "#14345a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(76.706 84.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M615.751,372.424,597.1,370.9v6.147h18.651Z",
    transform: "translate(-597.1 -370.9)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(102.108 86.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M693.8,378.8v4.072h2.653V379.01Z",
    transform: "translate(-693.8 -378.8)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(61.155 83.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M544.284,366.625,537.9,366.1v7.408h6.383Z",
    transform: "translate(-537.9 -366.1)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(0 83.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M366.255,373.508h-59.5a1.648,1.648,0,0,1-1.655-1.655v-4.1a1.648,1.648,0,0,1,1.655-1.655h59.5Z",
    transform: "translate(-305.1 -366.1)",
    fill: "#14345a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(0.158 0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M366.7,367.172V366.2H307.2a1.6,1.6,0,0,0-1.5.972Z",
    transform: "translate(-305.7 -366.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(2.785 1.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M320.534,375.191h-3.651a1.177,1.177,0,0,1-1.182-1.182v-.026a1.177,1.177,0,0,1,1.182-1.182h3.651a1.177,1.177,0,0,1,1.182,1.182v.026A1.145,1.145,0,0,1,320.534,375.191Z",
    transform: "translate(-315.7 -372.8)",
    fill: "#68e52f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(50.095 1.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M500.634,375.191h-3.651a1.177,1.177,0,0,1-1.182-1.182v-.026a1.177,1.177,0,0,1,1.182-1.182h3.651a1.177,1.177,0,0,1,1.182,1.182v.026A1.161,1.161,0,0,1,500.634,375.191Z",
    transform: "translate(-495.8 -372.8)",
    fill: "#68e52f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(89.946 60.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585-2",
    "data-name": "Rectangle 585",
    width: 15.419,
    height: 12.713,
    transform: "translate(172.496 123.17)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586-2",
    "data-name": "Rectangle 586",
    width: 15.419,
    height: 12.713,
    transform: "translate(164.786 123.17)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065-2",
    "data-name": "Path 2065",
    d: "M2390.813,1575.319h-2.443l.215-.687-.215-.491h2.443Z",
    transform: "translate(-2202.907 -1442.659)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066-2",
    "data-name": "Path 2066",
    d: "M2286.752,1500.259h-2.443l.215-.688-.215-.491h2.443Z",
    transform: "translate(-2106.548 -1373.154)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067-2",
    "data-name": "Path 2067",
    d: "M2317.32,1499.08h2.443l-.215.687.215.492h-2.443Z",
    transform: "translate(-2137.116 -1373.154)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068-2",
    "data-name": "Path 2068",
    d: "M2108.96,1591.92h2.444l-.215.688.215.491h-2.444Z",
    transform: "translate(-1944.174 -1459.123)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(96.296 51.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585-3",
    "data-name": "Rectangle 585",
    width: 11.185,
    height: 9.223,
    transform: "translate(170.379 123.17)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586-3",
    "data-name": "Rectangle 586",
    width: 11.185,
    height: 9.223,
    transform: "translate(164.786 123.17)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065-3",
    "data-name": "Path 2065",
    d: "M2390.142,1574.995h-1.772l.156-.5-.156-.356h1.772Z",
    transform: "translate(-2208.584 -1444.941)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066-3",
    "data-name": "Path 2066",
    d: "M2286.082,1499.935h-1.772l.156-.5-.156-.356h1.772Z",
    transform: "translate(-2110.111 -1373.91)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067-3",
    "data-name": "Path 2067",
    d: "M2317.32,1499.08h1.772l-.156.5.156.357h-1.772Z",
    transform: "translate(-2141.349 -1373.91)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068-3",
    "data-name": "Path 2068",
    d: "M2108.96,1591.92h1.773l-.156.5.156.356h-1.773Z",
    transform: "translate(-1944.174 -1461.766)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(114.296 65.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585-4",
    "data-name": "Rectangle 585",
    width: 9.68,
    height: 7.981,
    transform: "translate(169.626 123.17)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586-4",
    "data-name": "Rectangle 586",
    width: 9.68,
    height: 7.981,
    transform: "translate(164.786 123.17)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065-4",
    "data-name": "Path 2065",
    d: "M2389.9,1574.88h-1.534l.135-.432-.135-.308h1.534Z",
    transform: "translate(-2210.603 -1445.752)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066-4",
    "data-name": "Path 2066",
    d: "M2285.843,1499.82h-1.534l.135-.432-.135-.308h1.534Z",
    transform: "translate(-2111.378 -1374.179)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067-4",
    "data-name": "Path 2067",
    d: "M2317.32,1499.08h1.534l-.135.432.135.309h-1.534Z",
    transform: "translate(-2142.855 -1374.179)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068-4",
    "data-name": "Path 2068",
    d: "M2108.96,1591.92h1.534l-.135.432.135.308h-1.534Z",
    transform: "translate(-1944.174 -1462.706)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(117.448 58.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585-5",
    "data-name": "Rectangle 585",
    width: 7.578,
    height: 6.249,
    transform: "translate(168.575 123.17)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586-5",
    "data-name": "Rectangle 586",
    width: 7.578,
    height: 6.249,
    transform: "translate(164.786 123.17)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065-5",
    "data-name": "Path 2065",
    d: "M2389.57,1574.719h-1.2l.105-.338-.105-.241h1.2Z",
    transform: "translate(-2213.421 -1446.885)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066-5",
    "data-name": "Path 2066",
    d: "M2285.51,1499.659h-1.2l.106-.338-.106-.241h1.2Z",
    transform: "translate(-2113.146 -1374.555)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067-5",
    "data-name": "Path 2067",
    d: "M2317.32,1499.08h1.2l-.106.338.106.242h-1.2Z",
    transform: "translate(-2144.957 -1374.555)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068-5",
    "data-name": "Path 2068",
    d: "M2108.96,1591.92h1.2l-.106.338.106.241h-1.2Z",
    transform: "translate(-1944.174 -1464.018)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(119.081 53.662)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585-6",
    "data-name": "Rectangle 585",
    width: 6.49,
    height: 5.351,
    transform: "translate(168.031 123.17)",
    fill: "#ed823a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586-6",
    "data-name": "Rectangle 586",
    width: 6.49,
    height: 5.351,
    transform: "translate(164.786 123.17)",
    fill: "#ff9e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065-6",
    "data-name": "Path 2065",
    d: "M2389.4,1574.636h-1.028l.09-.289-.09-.207h1.028Z",
    transform: "translate(-2214.88 -1447.471)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066-6",
    "data-name": "Path 2066",
    d: "M2285.338,1499.576h-1.028l.091-.29-.091-.207h1.028Z",
    transform: "translate(-2114.062 -1374.749)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067-6",
    "data-name": "Path 2067",
    d: "M2317.32,1499.08h1.029l-.091.289.091.207h-1.029Z",
    transform: "translate(-2146.044 -1374.749)",
    fill: "#dd732c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068-6",
    "data-name": "Path 2068",
    d: "M2108.96,1591.92h1.029l-.091.29.091.207h-1.029Z",
    transform: "translate(-1944.174 -1464.697)",
    fill: "#ffb27d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoovingBanner);
export default __webpack_public_path__ + "static/media/mooving_banner.a02e6753f7d3199a62cd9bbaa2240c19.svg";
export { ForwardRef as ReactComponent };